module.exports = __webpack_public_path__ + "static/media/md-globe.a71da31c.svg";